import React, { useEffect, useMemo, useState } from 'react';
import { DayPicker as DayPickerComponent, NextMonthButton, PreviousMonthButton, Day } from 'react-day-picker';
import 'react-day-picker/style.css';
import enUS from 'date-fns/locale/en-US';
import { tryGetLocale } from './dateFnsLocales';

const useLocale = (localeName) => {
  const [locale, setLocale] = useState(enUS);

  useEffect(() => {
    if (!localeName) return;
    const loadLocale = async () => {
      try {
        const locale = await tryGetLocale(localeName);
        setLocale(locale.default);
      } catch (error) {
        console.error(`Error loading locale ${localeName}:`, error);
      }
    };

    loadLocale();
  }, [localeName]);

  return locale;
};


export const IntlDayPicker = (props) => {
  const {
    locale = 'en-US',
    translationLocale = 'en-US',
    mode = 'single',
    syncTranslation = false,
    rootClassName = 'rdp-root',
    classNames = {},
    ...rest
  } = props;

  const dayPickerLocale = useMemo(
    () => (syncTranslation ? locale : translationLocale),
    [locale, translationLocale, syncTranslation],
  );

  const dateFnsLocale = useLocale(dayPickerLocale);

  return (
    <DayPickerComponent
      locale={dateFnsLocale}
      mode={mode}
      classNames={{
        root: rootClassName,
        ...classNames,
      }}
      {...rest}
    />
  );
};

export default IntlDayPicker;

export { NextMonthButton, PreviousMonthButton, Day };
